module.exports = __webpack_public_path__ + "static/media/logo.bbba0f01.png";